module.exports = __webpack_public_path__ + "img/home_view_pager_001.fbf5bb7c.png";